module.exports = __webpack_public_path__ + "img/25_fineStaff_qmm.010b6731.png";